import Swiper from 'swiper';
import cursor, { cursors } from '../../cursor';
import smoothScroll from '../../smooth-scroll';

const addZero = (int) => {
  if (int < 10) {
    return `0${int}`;
  }
  return int;
};

const cw = document.createElement('div');
document.body.appendChild(cw);
cw.classList.add('grid-container');
const gridContainer = document.createElement('div');
cw.appendChild(gridContainer);
const containerWidth = () => Math.floor(0.5 * (window.innerWidth - gridContainer.clientWidth));

function debounce(fn, ms) {
  let timeout;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(fn, ms);
  };
}

function carousel(el) {
  const { carouselSlider } = el.dataset;
  const links = el.querySelectorAll('a');
  let swiper;
  switch (carouselSlider) {
    case 'article':
    case 'blog':
      swiper = new Swiper(el, {
        breakpoints: {
          639: {
            slidesPerView: 1.3,
            spaceBetween: 40,
          },
          1199: {
            slidesPerView: 2.2,
            spaceBetween: 96,
          },
          1440: {
            slidesPerView: 2.8,
          },
        },
        freeMode: true,
        keyboard: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true,
        },
        preloadImages: false,
        slidesPerView: 2.8,
        spaceBetween: 150,
        speed: 1000,
        watchSlidesVisibility: true,
      });
      swiper.on('progress', () => {
        swiper.slidesGrid.forEach((slidePos, i) => {
          if (slidePos + swiper.translate < swiper.size + 200) {
            const slide = swiper.slides[i];
            if (!slide.querySelector('.swiper-lazy-loaded')) {
              swiper.lazy.loadInSlide(i);
            }
          }
        });
      });
      break;
    case 'project':
      swiper = new Swiper(el, {
        breakpoints: {
          639: {
            spaceBetween: 16,
            slidesPerView: 375 / (375 - 64),
          },
          1023: {
            spaceBetween: 32,
            slidesPerView: 1.42,
          },
          1199: {
            spaceBetween: 64,
            slidesPerView: 1.42,
          },
          1439: {
            spaceBetween: 96,
            slidesPerView: 1.42,
          },
        },
        freeMode: true,
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          formatFractionCurrent: addZero,
          formatFractionTotal: addZero,
        },
        preloadImages: false,
        slidesPerView: 1.42,
        spaceBetween: 152,
        speed: 500,
        watchSlidesVisibility: true,
      });
      // swiper.prependSlide('<div class="swiper-slide"></div>');
      // swiper.appendSlide('<div class="swiper-slide"></div>');
      swiper.slideTo(0, 0);
      break;
    case 'awards':
      swiper = new Swiper(el, {
        breakpoints: {
          639: {
            slidesPerView: 1.5,
            slidesPerColumn: 1,
            spaceBetween: 32,
          },
          1023: {
            // slidesOffsetBefore: 32,
            // slidesOffsetAfter: 32,
            slidesPerView: 2.5,
          },
          1199: {
            slidesPerView: 3.5,
          },
        },
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
        preloadImages: false,
        // slidesOffsetBefore: 64,
        // slidesOffsetAfter: 64,
        slidesPerColumn: 2,
        slidesPerView: 4,
        spaceBetween: 96,
        watchSlidesVisibility: true,
      });
      break;
    default:
      swiper = new Swiper(el);
  }

  // cursor
  el.addEventListener('mouseenter', (e) => {
    cursor.setBgImage(cursors.MOVE);
    cursor.setPosition(e.x, e.y);
    cursor.toggle(true);
  });
  el.addEventListener('mouseleave', () => cursor.toggle(false));
  el.addEventListener('mousemove', e => cursor.setPosition(e.x, e.y));
  links.forEach((link) => {
    link.addEventListener('mouseenter', () => cursor.setBgImage(cursors.VIEW));
    link.addEventListener('mouseleave', () => cursor.setBgImage(cursors.MOVE));
  });
  swiper.on('touchMove', e => cursor.setPosition(e.x, e.y));

  // adjust to container
  if ('adjustToContainer' in el.dataset) {
    const onResize = () => {
      const w2 = containerWidth();
      swiper.params.slidesOffsetBefore = w2;
      swiper.params.slidesOffsetAfter = w2;
      swiper.update();
      swiper.slideTo(0, 0);
    };
    onResize();
    window.addEventListener('resize', debounce(onResize, 100));
  }
  return swiper;
}

const lazyCarouselObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      carousel(entry.target);
      lazyCarouselObserver.unobserve(entry.target);
    }
  });
}, { rootMargin: '0px 0px 1000px' });

export default (nodeList = []) => {
  if (smoothScroll.isEnabled) {
    // convert nodelist to array
    const arr = [];
    nodeList.forEach(el => arr.push(el));
    smoothScroll.onEnter((section, sections) => {
      const i = sections.indexOf(section);
      // while scrolling, initialize carousel 2 smooth scroll sections
      // before carousel section has entered
      arr.forEach((el, k) => {
        for (let j = i; j < i + 2; j++) {
          if (sections[j] && sections[j].contains(el)) {
            carousel(el);
            arr.splice(k, 1);
          }
        }
      });
    });
  } else {
    lazyCarouselObserver.disconnect();
    nodeList.forEach((el) => {
      lazyCarouselObserver.observe(el);
    });
  }
};
